import React from 'react'
import { Layout, Drawer } from 'antd'
import { CloseOutlined, MenuOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import SimpleBar from 'simplebar-react'

import { toogle_setting } from '../../../redux/slice/settings'
import Menu from './menu'

const MenuIdx = () => {
  const isMobileView = useSelector(s => s._settings.isMobileView)
  return isMobileView ? <MobileMenu /> : <DesktopMenu />
}

export default MenuIdx

const DesktopMenu = () => {
  const dispatch = useDispatch()
  const isSiderCollapsed = useSelector(s => s._settings.isSiderCollapsed)

  const onCollapse = () => {
    dispatch(toogle_setting('isSiderCollapsed'))
  }

  return (
    <Layout.Sider width={256} collapsible collapsed={isSiderCollapsed} onCollapse={onCollapse}>
      <SimpleBar style={{ height: '100%' }}>
        <Menu />
      </SimpleBar>
    </Layout.Sider>
  )
}

const MobileMenu = () => {
  const dispatch = useDispatch()
  const isMobileMenuOpen = useSelector(s => s._settings.isMobileMenuOpen)

  const onClose = () => {
    dispatch(toogle_setting('isMobileMenuOpen'))
  }

  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          zIndex: 1001,
          top: '70px',
          backgroundColor: 'rgb(0, 21, 41)',
          padding: '4px',
          borderRadius: '0 4px 4px 0',
          transition: 'left 0.3s',
          left: isMobileMenuOpen ? '256px' : '0px',
        }}
      >
        {isMobileMenuOpen ? <CloseOutlined style={{ fontSize: 24, color: 'white' }} /> : <MenuOutlined style={{ fontSize: 24, color: 'white' }} />}
      </div>

      <Drawer
        placement="left"
        open={isMobileMenuOpen}
        onClose={onClose}
        closable={false}
        width={256}
        bodyStyle={{
          padding: 0,
          backgroundColor: 'rgb(0, 21, 41)',
        }}
        contentWrapperStyle={{
          top: 64,
        }}
      >
        <Menu />
      </Drawer>
    </>
  )
}
